module.exports = __webpack_public_path__ + "img/brunobici.08c3db02.png";